import { cn } from "../lib/utils";

const VELLUM_LOGO_LIGHT = "https://assets.vellum.health/logos/logo-light.png";
const VELLUM_LOGO_DARK = "https://assets.vellum.health/logos/logo-dark.png";

export function Logo({
  variant = "light",
  size = "normal",
  href = "/",
  className = "",
}: {
  variant?: "light" | "dark";
  size?: "small" | "normal";
  // null renders the logo without a link
  href?: string | null;
  className?: string;
}) {
  const image = (
    <img
      src={variant === "light" ? VELLUM_LOGO_LIGHT : VELLUM_LOGO_DARK}
      alt="Vellum Logo"
      className={cn(
        size === "small"
          ? "w-[100px] sm:w-[150px] mx-auto"
          : "w-[150px] sm:w-[300px] mx-auto",
        className,
      )}
    />
  );
  if (href === null) {
    return image;
  }
  return <a href={href}>{image}</a>;
}
